import { Amplify } from 'aws-amplify';

const apiEndpoint = process.env.REACT_APP_PARTNER_MANAGER_APPSYNC_ENDPOINT;
const apiRegion = process.env.REACT_APP_PARTNER_MANAGER_APPSYNC_REGION;

if (!apiEndpoint) {
  console.warn('⚠️  WARNING: REACT_APP_PARTNER_MANAGER_APPSYNC_ENDPOINT is not set');
}

if (!apiRegion) {
  console.warn('⚠️  WARNING: REACT_APP_APPSYNC_REGION is not set');
}

/**
 * Initialize Amplify with OIDC authentication using Okta token
 * @param oktaAuth - Okta Auth instance
 */
export const configureAmplifyWithOkta = (oktaAuth) => {
  if (!oktaAuth) {
    throw new Error('OktaAuth instance is required to configure Amplify');
  }

  Amplify.configure(
    {
      API: {
        Events: {
          endpoint: apiEndpoint,
          region: apiRegion,
          defaultAuthMode: 'oidc',
        },
      },
    },
    {
      Auth: {
        tokenProvider: {
          getTokens: async () => {
            const accessToken = await oktaAuth.getAccessToken();
            if (!accessToken) {
              throw new Error('No access token available from Okta');
            }
            return {
              accessToken: {
                payload: {},
                toString: () => accessToken,
              },
            };
          },
        },
      },
    }
  );

  console.log('Amplify configured with Okta OIDC authentication');
};

